(function () {
'use strict';

if (
window.DLTHomeHeroV50 &&
typeof window.DLTHomeHeroV50.initAll === 'function'
) {
window.DLTHomeHeroV50.initAll(document);
return;
}

function initializeDltHero(root) {
if (
!root ||
root.dataset.dltLux33Ready === 'true'
) {
return;
}

root.dataset.dltLux33Ready = 'true';

var controller = typeof AbortController === 'function'
? new AbortController()
: null;
var signal = controller ? controller.signal : null;
var slides = Array.prototype.slice.call(
root.querySelectorAll('[data-dlt-lux33-slide]')
);
var dots = Array.prototype.slice.call(
root.querySelectorAll('[data-dlt-lux33-dot]')
);
var previousButton = root.querySelector(
'[data-dlt-lux33-prev]'
);
var nextButton = root.querySelector(
'[data-dlt-lux33-next]'
);
var progress = root.querySelector(
'[data-dlt-lux33-progress]'
);
var total = slides.length;

if (!total) return;

var current = 0;
var autoplayTimer = 0;
var startupTimer = 0;
var progressRaf = 0;
var observer = null;
var currentDuration = Number(
root.dataset.autoplaySpeed || 6500
);
var startDelay = Number(
root.dataset.autoplayDelay || 1400
);
var mobileQuery = window.matchMedia
? window.matchMedia('(max-width: 989px)')
: null;
var motionQuery = window.matchMedia
? window.matchMedia(
'(prefers-reduced-motion: reduce)'
)
: null;
var isMobile = mobileQuery
? mobileQuery.matches
: window.innerWidth < 990;
var autoplay =
root.dataset.autoplay === 'true' &&
total > 1;
var mobileAutoplay =
root.dataset.mobileAutoplay === 'true';
var pauseHover =
root.dataset.pauseHover === 'true';
var pauseFocus =
root.dataset.pauseFocus === 'true';
var reducedMotion = !!(
motionQuery && motionQuery.matches
);
var visible = true;
var paused = false;
var destroyed = false;
var startupComplete = false;
var touchStartX = 0;
var suppressSlideClickUntil = 0;
var mediaPrewarmTimer = 0;
var mediaPrewarmIdle = 0;

if (isMobile && !mobileAutoplay) {
autoplay = false;
}

if (reducedMotion) {
autoplay = false;
}

function addListener(
target,
type,
handler,
options
) {
if (
!target ||
typeof target.addEventListener !== 'function'
) {
return;
}

if (signal && typeof options === 'object') {
var nextOptions = {};

Object.keys(options || {}).forEach(
function (key) {
nextOptions[key] = options[key];
}
);

nextOptions.signal = signal;
target.addEventListener(
type,
handler,
nextOptions
);
return;
}

if (signal && options == null) {
target.addEventListener(
type,
handler,
{ signal: signal }
);
return;
}

target.addEventListener(
type,
handler,
options
);
}

function hydrateSlideMedia(slide, priority) {
if (!slide) return;

var picture = slide.querySelector(
'[data-dlt-lux33-lazy-picture]'
);

if (
!picture ||
picture.dataset.loaded === 'true'
) {
return;
}

Array.prototype.forEach.call(
picture.querySelectorAll(
'source[data-srcset]'
),
function (source) {
source.srcset =
source.getAttribute('data-srcset') || '';
source.removeAttribute('data-srcset');
}
);

var image = picture.querySelector(
'[data-dlt-lux33-lazy-image]'
);

if (image) {
var srcset =
image.getAttribute('data-srcset');
var src = image.getAttribute('data-src');

image.loading = 'eager';
image.fetchPriority = priority === 'low' ? 'low' : 'auto';

if (srcset) {
image.srcset = srcset;
image.removeAttribute('data-srcset');
}

if (src) {
image.src = src;
image.removeAttribute('data-src');
}
}

picture.dataset.loaded = 'true';
}


function connectionAllowsPrewarm() {
var connection =
navigator.connection ||
navigator.mozConnection ||
navigator.webkitConnection;

if (!connection) return true;
if (connection.saveData) return false;

var effectiveType = String(
connection.effectiveType || ''
).toLowerCase();

return effectiveType.indexOf('2g') === -1;
}

function cancelMediaPrewarm() {
if (mediaPrewarmTimer) {
window.clearTimeout(mediaPrewarmTimer);
mediaPrewarmTimer = 0;
}

if (
mediaPrewarmIdle &&
typeof window.cancelIdleCallback === 'function'
) {
window.cancelIdleCallback(mediaPrewarmIdle);
mediaPrewarmIdle = 0;
}
}

function prewarmNextSlideMedia() {
mediaPrewarmTimer = 0;
mediaPrewarmIdle = 0;

if (
destroyed ||
!autoplay ||
total < 2 ||
document.hidden ||
!visible ||
!connectionAllowsPrewarm()
) {
return;
}

var nextIndex = (current + 1) % total;
hydrateSlideMedia(slides[nextIndex], 'low');
}

function scheduleMediaPrewarm(delay) {
cancelMediaPrewarm();

if (
destroyed ||
!autoplay ||
total < 2 ||
!connectionAllowsPrewarm()
) {
return;
}

mediaPrewarmTimer = window.setTimeout(
function () {
mediaPrewarmTimer = 0;

if ('requestIdleCallback' in window) {
mediaPrewarmIdle = window.requestIdleCallback(
prewarmNextSlideMedia,
{ timeout: 1800 }
);
} else {
prewarmNextSlideMedia();
}
},
Math.max(Number(delay) || 0, 0)
);
}

function resetProgress() {
if (!progress) return;

if (progressRaf) {
window.cancelAnimationFrame(progressRaf);
progressRaf = 0;
}

progress.style.transition = 'none';
progress.style.transform = 'scaleX(0)';
}

function startProgress(duration) {
if (!progress || reducedMotion) return;

resetProgress();

progressRaf = window.requestAnimationFrame(
function () {
progressRaf = window.requestAnimationFrame(
function () {
progressRaf = 0;

if (destroyed) return;

progress.style.transition =
'transform ' +
duration +
'ms linear';
progress.style.transform =
'scaleX(1)';
}
);
}
);
}

function setFocusable(slide, active) {
Array.prototype.forEach.call(
slide.querySelectorAll(
'[data-dlt-lux33-focusable], ' +
'[data-dlt-lux33-hotspot-button]'
),
function (element) {
if (active) {
element.removeAttribute('aria-hidden');

if (
element.hasAttribute(
'data-dlt-original-tabindex'
)
) {
var original = element.getAttribute(
'data-dlt-original-tabindex'
);

if (original === '') {
element.removeAttribute('tabindex');
} else {
element.setAttribute(
'tabindex',
original
);
}

element.removeAttribute(
'data-dlt-original-tabindex'
);
} else if (
element.getAttribute('tabindex') === '-1'
) {
element.removeAttribute('tabindex');
}
} else {
if (
!element.hasAttribute(
'data-dlt-original-tabindex'
)
) {
element.setAttribute(
'data-dlt-original-tabindex',
element.getAttribute('tabindex') || ''
);
}

element.setAttribute('tabindex', '-1');
element.setAttribute(
'aria-hidden',
'true'
);
}
}
);
}

function updateDots() {
dots.forEach(function (dot, index) {
var active = index === current;

dot.classList.toggle(
'is-active',
active
);
dot.setAttribute(
'aria-current',
active ? 'true' : 'false'
);
});
}

function closeHotspots() {
Array.prototype.forEach.call(
root.querySelectorAll(
'[data-dlt-lux33-hotspot-button]' +
'[aria-expanded="true"]'
),
function (button) {
button.setAttribute(
'aria-expanded',
'false'
);
}
);
}

function clearAutoplay(resetVisual) {
if (autoplayTimer) {
window.clearTimeout(autoplayTimer);
autoplayTimer = 0;
}

if (startupTimer) {
window.clearTimeout(startupTimer);
startupTimer = 0;
}

if (resetVisual !== false) {
resetProgress();
}
}

function scheduleAutoplay(delay) {
clearAutoplay();

if (
!autoplay ||
paused ||
!visible ||
document.hidden ||
reducedMotion
) {
return;
}

currentDuration =
Number(delay) ||
Number(root.dataset.autoplaySpeed || 6500);

startProgress(currentDuration);

autoplayTimer = window.setTimeout(
function () {
goTo(current + 1, false);
scheduleAutoplay(
Number(
root.dataset.autoplaySpeed || 6500
)
);
},
currentDuration
);
}

function restartAutoplay() {
if (!autoplay || !startupComplete) return;

scheduleAutoplay(
Number(root.dataset.autoplaySpeed || 6500)
);
}

function scheduleInitialAutoplay() {
clearAutoplay();

if (
!autoplay ||
startupComplete ||
paused ||
!visible ||
document.hidden ||
reducedMotion
) {
return;
}

startupTimer = window.setTimeout(
function () {
startupTimer = 0;
startupComplete = true;
scheduleAutoplay(
Number(
root.dataset.autoplaySpeed || 6500
)
);
},
Math.max(startDelay, 0)
);
}

function resumeAutoplay() {
if (startupComplete) {
restartAutoplay();
} else {
scheduleInitialAutoplay();
}
}

function goTo(index, manual) {
var target = (index + total) % total;

if (target === current) {
if (manual) {
startupComplete = true;
restartAutoplay();
}
return;
}

hydrateSlideMedia(slides[target]);
closeHotspots();

slides[current].classList.remove(
'is-active'
);
slides[current].setAttribute(
'aria-hidden',
'true'
);
setFocusable(slides[current], false);

current = target;

slides[current].classList.add(
'is-active'
);
slides[current].setAttribute(
'aria-hidden',
'false'
);
setFocusable(slides[current], true);

updateDots();
resetProgress();
scheduleMediaPrewarm(900);

if (manual) {
startupComplete = true;
restartAutoplay();
}
}

function nextSlide(manual) {
goTo(current + 1, manual);
}

function previousSlide(manual) {
goTo(current - 1, manual);
}

dots.forEach(function (dot) {
addListener(dot, 'click', function () {
goTo(
Number(dot.dataset.index || 0),
true
);
});
});

if (previousButton) {
addListener(
previousButton,
'click',
function () {
previousSlide(true);
}
);
}

if (nextButton) {
addListener(
nextButton,
'click',
function () {
nextSlide(true);
}
);
}

addListener(
root,
'touchstart',
function (event) {
if (
!event.touches ||
!event.touches.length
) {
return;
}

touchStartX =
event.touches[0].clientX;
suppressSlideClickUntil = 0;
},
{ passive: true }
);

addListener(
root,
'touchend',
function (event) {
if (
!event.changedTouches ||
!event.changedTouches.length ||
total < 2
) {
return;
}

var difference =
touchStartX -
event.changedTouches[0].clientX;

if (Math.abs(difference) > 42) {
suppressSlideClickUntil = Date.now() + 500;
if (difference > 0) {
nextSlide(true);
} else {
previousSlide(true);
}
}
},
{ passive: true }
);

addListener(root, 'click', function (event) {
if (
event.detail > 0 &&
Date.now() < suppressSlideClickUntil &&
event.target.closest &&
event.target.closest('[data-dlt-lux33-slide-link]')
) {
event.preventDefault();
}
});

if (pauseHover) {
addListener(root, 'mouseenter', function () {
if (isMobile) return;

paused = true;
clearAutoplay();
});

addListener(root, 'mouseleave', function () {
if (isMobile) return;

paused = false;
resumeAutoplay();
});
}

if (pauseFocus) {
addListener(root, 'focusin', function () {
paused = true;
clearAutoplay();
});

addListener(
root,
'focusout',
function (event) {
if (
event.relatedTarget &&
root.contains(event.relatedTarget)
) {
return;
}

paused = false;
resumeAutoplay();
}
);
}

addListener(
document,
'visibilitychange',
function () {
if (document.hidden) {
visible = false;
clearAutoplay();
cancelMediaPrewarm();
} else {
visible = true;
resumeAutoplay();
scheduleMediaPrewarm(900);
}
}
);

if ('IntersectionObserver' in window) {
observer = new IntersectionObserver(
function (entries) {
var entry = entries[0];

if (!entry) return;

visible =
entry.isIntersecting &&
entry.intersectionRatio > 0.08;

if (visible) {
resumeAutoplay();
scheduleMediaPrewarm(900);
} else {
clearAutoplay();
cancelMediaPrewarm();
}
},
{ threshold: [0, 0.08, 0.35] }
);

observer.observe(root);
}

addListener(root, 'click', function (event) {
var button = event.target.closest(
'[data-dlt-lux33-hotspot-button]'
);

if (!button) return;

var expanded =
button.getAttribute('aria-expanded') ===
'true';

closeHotspots();
button.setAttribute(
'aria-expanded',
expanded ? 'false' : 'true'
);
});

addListener(
document,
'click',
function (event) {
if (root.contains(event.target)) return;

closeHotspots();
}
);

addListener(
document,
'keydown',
function (event) {
if (event.key === 'Escape') {
closeHotspots();
}
}
);

if (
motionQuery &&
typeof motionQuery.addEventListener ===
'function'
) {
addListener(
motionQuery,
'change',
function (event) {
reducedMotion = event.matches;

if (reducedMotion) {
clearAutoplay();
if (progress) {
progress.style.transform =
'scaleX(1)';
}
} else {
autoplay =
root.dataset.autoplay === 'true' &&
total > 1 &&
(!isMobile || mobileAutoplay);
startupComplete = true;
restartAutoplay();
}
}
);
}

slides.forEach(function (slide, index) {
setFocusable(slide, index === current);
});

hydrateSlideMedia(slides[0]);
updateDots();

var criticalImage = slides[0]
? slides[0].querySelector(
'.dlt-lux33__image--critical'
)
: null;

function markHeroReady() {
window.requestAnimationFrame(function () {
root.classList.add('is-ready');
scheduleMediaPrewarm(700);
});
}

if (
criticalImage &&
!criticalImage.complete
) {
addListener(
criticalImage,
'load',
markHeroReady,
{ once: true }
);
addListener(
criticalImage,
'error',
markHeroReady,
{ once: true }
);
} else {
markHeroReady();
}

if (autoplay) {
scheduleInitialAutoplay();
} else if (progress) {
startupComplete = true;
progress.style.transition = 'none';
progress.style.transform = 'scaleX(1)';
}

function destroyHero() {
if (destroyed) return;

destroyed = true;
clearAutoplay();
cancelMediaPrewarm();

if (observer) {
observer.disconnect();
}

if (controller) {
controller.abort();
}

root.dataset.dltLux33Ready = 'false';
root.__dltLux33Destroy = null;
}

root.__dltLux33Destroy = destroyHero;
}

function initAll(scope) {
var context = scope && scope.querySelectorAll
? scope
: document;

var roots = [];

if (
context.matches &&
context.matches('[data-dlt-lux33]')
) {
roots.push(context);
}

Array.prototype.push.apply(
roots,
context.querySelectorAll('[data-dlt-lux33]')
);

roots.forEach(function (root) {
initializeDltHero(root);
});
}

function scheduleInit(scope, immediate) {
var run = function () {
initAll(scope || document);
};

if (immediate) {
run();
return;
}

if ('requestIdleCallback' in window) {
window.requestIdleCallback(run, { timeout: 900 });
} else {
window.setTimeout(run, 120);
}
}

function destroyWithin(scope) {
if (!scope || !scope.querySelectorAll) return;

var roots = [];

if (
scope.matches &&
scope.matches('[data-dlt-lux33]')
) {
roots.push(scope);
}

Array.prototype.push.apply(
roots,
scope.querySelectorAll('[data-dlt-lux33]')
);

roots.forEach(function (root) {
if (typeof root.__dltLux33Destroy === 'function') {
root.__dltLux33Destroy();
}
});
}

window.DLTHomeHeroV50 = {
initAll: initAll,
destroyWithin: destroyWithin
};

if (document.readyState === 'loading') {
document.addEventListener(
'DOMContentLoaded',
function () {
scheduleInit(document, false);
},
{ once: true }
);
} else {
scheduleInit(document, false);
}

document.addEventListener(
'shopify:section:load',
function (event) {
scheduleInit(event.target, true);
}
);

document.addEventListener(
'shopify:section:unload',
function (event) {
destroyWithin(event.target);
}
);
})();
